import { render, staticRenderFns } from "./EditShow.vue?vue&type=template&id=38428aab&"
import script from "./EditShow.vue?vue&type=script&lang=ts&"
export * from "./EditShow.vue?vue&type=script&lang=ts&"
import style0 from "./EditShow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports